import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasSanPedro() {
  return (
    <CityPagePersianas
      name="San Pedro de Alcántara"
      slug="san-pedro-de-alcantara"
      cp="29670"
      poblacion={40000}
      zonaGeo="Costa del Sol Occidental"
      lat={36.4853}
      lng={-4.9911}
      zonas={[
        "Centro San Pedro",
        "Guadalmina Alta",
        "Guadalmina Baja",
        "Linda Vista",
        "Nueva Alcántara",
      ]}
      landmarks={[
        "Bulevar San Pedro",
        "Iglesia San Pedro",
        "Real Club de Golf Guadalmina",
      ]}
      municipiosLimitrofes={[
        "Marbella",
        "Benahavís",
        "Estepona",
      ]}
      festivalLocal="Feria de San Pedro, mediados de octubre"
      contextoTipologico="Zona residencial premium anexa a Marbella, urbanizaciones de golf Guadalmina, villas con grandes terrazas."
      isCoreZone={false}
    />
  );
}